module.exports = __webpack_public_path__ + "img/mk.svg";